// extracted by mini-css-extract-plugin
module.exports = {"listItemText":"ScoreTogglePanel_listItemText__ywcgz"};